import { createSelector } from 'reselect';

const selectPremiumPage = state => state.premiumPage;

const makeSelectDonationInfor = () => createSelector(
  selectPremiumPage,
  premiumState => premiumState.donation,
);

export { makeSelectDonationInfor };
